import styled, { css } from 'styled-components';

import { PseudoPlacement } from './Popup';

const getPlacementMapping = (size: number) => ({
    top: `bottom: -${size}px;`,
    bottom: `top: -${size}px;`,
    left: `right: -${size}px;`,
    right: `left: -${size}px;`,
});

const getCaretStylesMapping = (size: number, background: string) => ({
    top: css`
        top: 0;
        left: -${size / 2}px;
        border-left: ${size}px solid transparent;
        border-right: ${size}px solid transparent;
        border-top: ${size}px solid ${background};
    `,
    bottom: css`
        top: 0;
        left: -${size / 2}px;
        border-left: ${size}px solid transparent;
        border-right: ${size}px solid transparent;
        border-bottom: ${size}px solid ${background};
    `,
    left: css`
        top: -${size / 2}px;
        left: 0;
        border-top: ${size}px solid transparent;
        border-bottom: ${size}px solid transparent;
        border-left: ${size}px solid ${background};
    `,
    right: css`
        top: -${size / 2}px;
        left: 0;
        border-top: ${size}px solid transparent;
        border-bottom: ${size}px solid transparent;
        border-right: ${size}px solid ${background};
    `,
});

export const Caret = styled.div<{ placement: PseudoPlacement; size: number }>`
    position: absolute;
    width: ${({ size }) => size}px;
    height: ${({ size }) => size}px;
    ${({ placement, size }) => getPlacementMapping(size)[placement]}

    &:after {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        pointer-events: none;
        ${({ placement, size, theme }) => getCaretStylesMapping(size, theme.bento.colors.background.main)[placement]}
    }
`;
